import { Reveal } from "@/components/Reveal";
import { WhatsAppButton } from "@/components/CTAButtons";
import { IMAGES, CONTACT } from "@/data/site";

const CHAPTERS = [
  { n: "01", title: "Experiência de sobra", text: "São mais de 20 anos percorrendo as rodovias de Rondônia e Mato Grosso, resgatando veículos e resolvendo emergências em qualquer situação." },
  { n: "02", title: "Equipe treinada", text: "Profissionais capacitados e comprometidos, prontos para agir com segurança e agilidade a qualquer hora do dia ou da noite." },
  { n: "03", title: "Equipamentos modernos", text: "Frota completa de guinchos leves, pesados e caminhões munck, preparada para todo tipo de veículo e carga." },
  { n: "04", title: "Compromisso com o cliente", text: "Atendimento ágil em rodovias e áreas urbanas, com transparência, preço justo e total segurança do início ao fim." },
];

export default function About() {
  return (
    <section id="sobre" className="relative overflow-hidden bg-white py-24 md:py-32" data-testid="about">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid gap-14 lg:grid-cols-2 lg:gap-20">
          <div>
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">Quem Somos</p>
              <h2 className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-brand-obsidian md:text-6xl">
                Referência em auto socorro <span className="text-brand-red">há {CONTACT.years}+ anos</span>
              </h2>
              <p className="mt-6 max-w-lg text-base leading-relaxed text-neutral-600">
                A Auto Socorro Pimenta nasceu para atender quem mais precisa: motoristas parados na
                estrada, empresas com cargas a movimentar e seguradoras que exigem agilidade. Ao longo
                de duas décadas construímos uma reputação sólida baseada em rapidez, segurança e respeito
                ao cliente.
              </p>
              <div className="mt-8">
                <WhatsAppButton label="Falar com a Equipe" testid="about-whatsapp" />
              </div>
            </Reveal>

            <div className="mt-12 grid grid-cols-3 gap-4">
              {[
                { k: "20+", v: "Anos de estrada" },
                { k: "24h", v: "Todos os dias" },
                { k: "13+", v: "Cidades atendidas" },
              ].map((s) => (
                <Reveal key={s.k} className="border-t border-black/10 pt-4">
                  <p className="font-display text-4xl text-brand-red md:text-5xl">{s.k}</p>
                  <p className="mt-1 text-xs uppercase tracking-wide text-neutral-500">{s.v}</p>
                </Reveal>
              ))}
            </div>
          </div>

          <div>
            <Reveal className="relative mb-10 overflow-hidden">
              <img src={IMAGES.fleetDirtLot} alt="Frota Auto Socorro Pimenta" loading="lazy" className="aspect-[4/3] w-full object-cover" />
              <div className="pointer-events-none absolute inset-0 border border-black/10" />
            </Reveal>
            <div className="space-y-8">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.n} delay={i * 0.05} className="flex gap-5 border-l-2 border-brand-red pl-5">
                  <span className="font-mono text-sm text-brand-red">{c.n}</span>
                  <div>
                    <h3 className="font-heading text-lg font-semibold uppercase tracking-wide text-brand-obsidian">{c.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-neutral-600">{c.text}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
